import { generateErrorMap } from "@saberhq/anchor-contrib";

export type CremaPositionWrapperIDL = {
  version: "0.1.0";
  name: "crema_position_wrapper";
  instructions: [
    {
      name: "newWrapper";
      accounts: [
        {
          name: "base";
          isMut: false;
          isSigner: true;
        },
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "swap";
          isMut: false;
          isSigner: false;
        },
        {
          name: "wrapMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        },
        {
          name: "mintBump";
          type: "u8";
        },
        {
          name: "etrMin";
          type: "i32";
        },
        {
          name: "etrMax";
          type: "i32";
        }
      ];
    },
    {
      name: "updateWrapper";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "etrMin";
          type: "i32";
        },
        {
          name: "etrMax";
          type: "i32";
        }
      ];
    },
    {
      name: "transferAdmin";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: true;
        },
        {
          name: "nextAdmin";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "acceptAdmin";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "pendingAdmin";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [];
    },
    {
      name: "mintWrapTokens";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "position";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wrapMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wrapTokenDestination";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "nftVault";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "swapPosition";
          isMut: false;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: true;
          isSigner: true;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        }
      ];
    },
    {
      name: "burnWrapTokens";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "position";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wrapMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wrapTokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftVault";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "closePosition";
      accounts: [
        {
          name: "position";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [];
    }
  ];
  accounts: [
    {
      name: "PositionWrapper";
      type: {
        kind: "struct";
        fields: [
          {
            name: "base";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "swapKey";
            type: "publicKey";
          },
          {
            name: "admin";
            type: "publicKey";
          },
          {
            name: "pendingAdmin";
            type: "publicKey";
          },
          {
            name: "wrapMint";
            type: "publicKey";
          },
          {
            name: "positionCount";
            type: "u64";
          },
          {
            name: "etrMax";
            type: "i32";
          },
          {
            name: "etrMin";
            type: "i32";
          },
          {
            name: "reserved";
            type: {
              array: ["u64", 16];
            };
          }
        ];
      };
    },
    {
      name: "Position";
      type: {
        kind: "struct";
        fields: [
          {
            name: "wrapper";
            type: "publicKey";
          },
          {
            name: "owner";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "index";
            type: "u64";
          },
          {
            name: "nftVault";
            type: "publicKey";
          },
          {
            name: "nftMint";
            type: "publicKey";
          },
          {
            name: "wrapBalance";
            type: "u64";
          },
          {
            name: "liquity";
            type: "u128";
          },
          {
            name: "lowerTick";
            type: "i32";
          },
          {
            name: "upperTick";
            type: "i32";
          },
          {
            name: "hold";
            type: "bool";
          },
          {
            name: "reserved";
            type: {
              array: ["u64", 16];
            };
          }
        ];
      };
    }
  ];
  events: [
    {
      name: "NewWrapperEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "wrapMint";
          type: "publicKey";
          index: false;
        },
        {
          name: "admin";
          type: "publicKey";
          index: false;
        },
        {
          name: "etrMin";
          type: "i32";
          index: false;
        },
        {
          name: "etrMax";
          type: "i32";
          index: false;
        }
      ];
    },
    {
      name: "UpdateWrapperEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "previousEtrMin";
          type: "i32";
          index: false;
        },
        {
          name: "previousEtrMax";
          type: "i32";
          index: false;
        },
        {
          name: "etrMin";
          type: "i32";
          index: false;
        },
        {
          name: "etrMax";
          type: "i32";
          index: false;
        }
      ];
    },
    {
      name: "TransferAdminEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "currentAdmin";
          type: "publicKey";
          index: false;
        },
        {
          name: "pendingAdmin";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "AcceptAdminEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "previousAdmin";
          type: "publicKey";
          index: false;
        },
        {
          name: "admin";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "MintWrapTokensEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "position";
          type: "publicKey";
          index: false;
        },
        {
          name: "nftMint";
          type: "publicKey";
          index: false;
        },
        {
          name: "authority";
          type: "publicKey";
          index: false;
        },
        {
          name: "lowerTick";
          type: "i32";
          index: false;
        },
        {
          name: "upperTick";
          type: "i32";
          index: false;
        },
        {
          name: "liquity";
          type: "u128";
          index: false;
        },
        {
          name: "amount";
          type: "u64";
          index: false;
        }
      ];
    },
    {
      name: "BurnWrapTokensEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "position";
          type: "publicKey";
          index: false;
        },
        {
          name: "nftMint";
          type: "publicKey";
          index: false;
        },
        {
          name: "amount";
          type: "u64";
          index: false;
        }
      ];
    }
  ];
  errors: [
    {
      code: 6000;
      name: "Unauthorized";
      msg: "Unauthorized.";
    },
    {
      code: 6001;
      name: "InsufficientBalance";
      msg: "Insufficient balance.";
    },
    {
      code: 6002;
      name: "CremaPositionNotFound";
      msg: "Crema position not found";
    },
    {
      code: 6003;
      name: "NotInEffectiveRange";
      msg: "Crema position range must overlap with effective range";
    },
    {
      code: 6004;
      name: "WrongSwapPosition";
      msg: "Wrong crema swap position account";
    },
    {
      code: 6005;
      name: "NotMatchSwapKey";
      msg: "Crema swap key not match";
    }
  ];
};
export type AnchorCremaPositionWrapper = {
  version: "0.1.0";
  name: "crema_position_wrapper";
  instructions: [
    {
      name: "newWrapper";
      accounts: [
        {
          name: "base";
          isMut: false;
          isSigner: true;
        },
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "swap";
          isMut: false;
          isSigner: false;
        },
        {
          name: "wrapMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        },
        {
          name: "mintBump";
          type: "u8";
        },
        {
          name: "etrMin";
          type: "i32";
        },
        {
          name: "etrMax";
          type: "i32";
        }
      ];
    },
    {
      name: "updateWrapper";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "etrMin";
          type: "i32";
        },
        {
          name: "etrMax";
          type: "i32";
        }
      ];
    },
    {
      name: "transferAdmin";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "admin";
          isMut: false;
          isSigner: true;
        },
        {
          name: "nextAdmin";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "acceptAdmin";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "pendingAdmin";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [];
    },
    {
      name: "mintWrapTokens";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "position";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wrapMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wrapTokenDestination";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "nftVault";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "swapPosition";
          isMut: false;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: true;
          isSigner: true;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        }
      ];
    },
    {
      name: "burnWrapTokens";
      accounts: [
        {
          name: "wrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "position";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wrapMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wrapTokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftVault";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "closePosition";
      accounts: [
        {
          name: "position";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [];
    }
  ];
  accounts: [
    {
      name: "positionWrapper";
      type: {
        kind: "struct";
        fields: [
          {
            name: "base";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "swapKey";
            type: "publicKey";
          },
          {
            name: "admin";
            type: "publicKey";
          },
          {
            name: "pendingAdmin";
            type: "publicKey";
          },
          {
            name: "wrapMint";
            type: "publicKey";
          },
          {
            name: "positionCount";
            type: "u64";
          },
          {
            name: "etrMax";
            type: "i32";
          },
          {
            name: "etrMin";
            type: "i32";
          },
          {
            name: "reserved";
            type: {
              array: ["u64", 16];
            };
          }
        ];
      };
    },
    {
      name: "position";
      type: {
        kind: "struct";
        fields: [
          {
            name: "wrapper";
            type: "publicKey";
          },
          {
            name: "owner";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "index";
            type: "u64";
          },
          {
            name: "nftVault";
            type: "publicKey";
          },
          {
            name: "nftMint";
            type: "publicKey";
          },
          {
            name: "wrapBalance";
            type: "u64";
          },
          {
            name: "liquity";
            type: "u128";
          },
          {
            name: "lowerTick";
            type: "i32";
          },
          {
            name: "upperTick";
            type: "i32";
          },
          {
            name: "hold";
            type: "bool";
          },
          {
            name: "reserved";
            type: {
              array: ["u64", 16];
            };
          }
        ];
      };
    }
  ];
  events: [
    {
      name: "NewWrapperEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "wrapMint";
          type: "publicKey";
          index: false;
        },
        {
          name: "admin";
          type: "publicKey";
          index: false;
        },
        {
          name: "etrMin";
          type: "i32";
          index: false;
        },
        {
          name: "etrMax";
          type: "i32";
          index: false;
        }
      ];
    },
    {
      name: "UpdateWrapperEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "previousEtrMin";
          type: "i32";
          index: false;
        },
        {
          name: "previousEtrMax";
          type: "i32";
          index: false;
        },
        {
          name: "etrMin";
          type: "i32";
          index: false;
        },
        {
          name: "etrMax";
          type: "i32";
          index: false;
        }
      ];
    },
    {
      name: "TransferAdminEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "currentAdmin";
          type: "publicKey";
          index: false;
        },
        {
          name: "pendingAdmin";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "AcceptAdminEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "previousAdmin";
          type: "publicKey";
          index: false;
        },
        {
          name: "admin";
          type: "publicKey";
          index: false;
        }
      ];
    },
    {
      name: "MintWrapTokensEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "position";
          type: "publicKey";
          index: false;
        },
        {
          name: "nftMint";
          type: "publicKey";
          index: false;
        },
        {
          name: "authority";
          type: "publicKey";
          index: false;
        },
        {
          name: "lowerTick";
          type: "i32";
          index: false;
        },
        {
          name: "upperTick";
          type: "i32";
          index: false;
        },
        {
          name: "liquity";
          type: "u128";
          index: false;
        },
        {
          name: "amount";
          type: "u64";
          index: false;
        }
      ];
    },
    {
      name: "BurnWrapTokensEvent";
      fields: [
        {
          name: "wrapper";
          type: "publicKey";
          index: false;
        },
        {
          name: "position";
          type: "publicKey";
          index: false;
        },
        {
          name: "nftMint";
          type: "publicKey";
          index: false;
        },
        {
          name: "amount";
          type: "u64";
          index: false;
        }
      ];
    }
  ];
  errors: [
    {
      code: 6000;
      name: "Unauthorized";
      msg: "Unauthorized.";
    },
    {
      code: 6001;
      name: "InsufficientBalance";
      msg: "Insufficient balance.";
    },
    {
      code: 6002;
      name: "CremaPositionNotFound";
      msg: "Crema position not found";
    },
    {
      code: 6003;
      name: "NotInEffectiveRange";
      msg: "Crema position range must overlap with effective range";
    },
    {
      code: 6004;
      name: "WrongSwapPosition";
      msg: "Wrong crema swap position account";
    },
    {
      code: 6005;
      name: "NotMatchSwapKey";
      msg: "Crema swap key not match";
    }
  ];
};

export const AnchorCremaPositionWrapperIDL: AnchorCremaPositionWrapper = {
  version: "0.1.0",
  name: "crema_position_wrapper",
  instructions: [
    {
      name: "newWrapper",
      accounts: [
        {
          name: "base",
          isMut: false,
          isSigner: true,
        },
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "swap",
          isMut: false,
          isSigner: false,
        },
        {
          name: "wrapMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
        {
          name: "mintBump",
          type: "u8",
        },
        {
          name: "etrMin",
          type: "i32",
        },
        {
          name: "etrMax",
          type: "i32",
        },
      ],
    },
    {
      name: "updateWrapper",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "etrMin",
          type: "i32",
        },
        {
          name: "etrMax",
          type: "i32",
        },
      ],
    },
    {
      name: "transferAdmin",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: true,
        },
        {
          name: "nextAdmin",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "acceptAdmin",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "pendingAdmin",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [],
    },
    {
      name: "mintWrapTokens",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "position",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wrapMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wrapTokenDestination",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "nftVault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "swapPosition",
          isMut: false,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: true,
          isSigner: true,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
      ],
    },
    {
      name: "burnWrapTokens",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "position",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wrapMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wrapTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftVault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "closePosition",
      accounts: [
        {
          name: "position",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [],
    },
  ],
  accounts: [
    {
      name: "positionWrapper",
      type: {
        kind: "struct",
        fields: [
          {
            name: "base",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "swapKey",
            type: "publicKey",
          },
          {
            name: "admin",
            type: "publicKey",
          },
          {
            name: "pendingAdmin",
            type: "publicKey",
          },
          {
            name: "wrapMint",
            type: "publicKey",
          },
          {
            name: "positionCount",
            type: "u64",
          },
          {
            name: "etrMax",
            type: "i32",
          },
          {
            name: "etrMin",
            type: "i32",
          },
          {
            name: "reserved",
            type: {
              array: ["u64", 16],
            },
          },
        ],
      },
    },
    {
      name: "position",
      type: {
        kind: "struct",
        fields: [
          {
            name: "wrapper",
            type: "publicKey",
          },
          {
            name: "owner",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "index",
            type: "u64",
          },
          {
            name: "nftVault",
            type: "publicKey",
          },
          {
            name: "nftMint",
            type: "publicKey",
          },
          {
            name: "wrapBalance",
            type: "u64",
          },
          {
            name: "liquity",
            type: "u128",
          },
          {
            name: "lowerTick",
            type: "i32",
          },
          {
            name: "upperTick",
            type: "i32",
          },
          {
            name: "hold",
            type: "bool",
          },
          {
            name: "reserved",
            type: {
              array: ["u64", 16],
            },
          },
        ],
      },
    },
  ],
  events: [
    {
      name: "NewWrapperEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "wrapMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "admin",
          type: "publicKey",
          index: false,
        },
        {
          name: "etrMin",
          type: "i32",
          index: false,
        },
        {
          name: "etrMax",
          type: "i32",
          index: false,
        },
      ],
    },
    {
      name: "UpdateWrapperEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "previousEtrMin",
          type: "i32",
          index: false,
        },
        {
          name: "previousEtrMax",
          type: "i32",
          index: false,
        },
        {
          name: "etrMin",
          type: "i32",
          index: false,
        },
        {
          name: "etrMax",
          type: "i32",
          index: false,
        },
      ],
    },
    {
      name: "TransferAdminEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "currentAdmin",
          type: "publicKey",
          index: false,
        },
        {
          name: "pendingAdmin",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "AcceptAdminEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "previousAdmin",
          type: "publicKey",
          index: false,
        },
        {
          name: "admin",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "MintWrapTokensEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "position",
          type: "publicKey",
          index: false,
        },
        {
          name: "nftMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "authority",
          type: "publicKey",
          index: false,
        },
        {
          name: "lowerTick",
          type: "i32",
          index: false,
        },
        {
          name: "upperTick",
          type: "i32",
          index: false,
        },
        {
          name: "liquity",
          type: "u128",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
      ],
    },
    {
      name: "BurnWrapTokensEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "position",
          type: "publicKey",
          index: false,
        },
        {
          name: "nftMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
      ],
    },
  ],
  errors: [
    {
      code: 6000,
      name: "Unauthorized",
      msg: "Unauthorized.",
    },
    {
      code: 6001,
      name: "InsufficientBalance",
      msg: "Insufficient balance.",
    },
    {
      code: 6002,
      name: "CremaPositionNotFound",
      msg: "Crema position not found",
    },
    {
      code: 6003,
      name: "NotInEffectiveRange",
      msg: "Crema position range must overlap with effective range",
    },
    {
      code: 6004,
      name: "WrongSwapPosition",
      msg: "Wrong crema swap position account",
    },
    {
      code: 6005,
      name: "NotMatchSwapKey",
      msg: "Crema swap key not match",
    },
  ],
};
export const CremaPositionWrapperJSON: CremaPositionWrapperIDL = {
  version: "0.1.0",
  name: "crema_position_wrapper",
  instructions: [
    {
      name: "newWrapper",
      accounts: [
        {
          name: "base",
          isMut: false,
          isSigner: true,
        },
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "swap",
          isMut: false,
          isSigner: false,
        },
        {
          name: "wrapMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
        {
          name: "mintBump",
          type: "u8",
        },
        {
          name: "etrMin",
          type: "i32",
        },
        {
          name: "etrMax",
          type: "i32",
        },
      ],
    },
    {
      name: "updateWrapper",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "etrMin",
          type: "i32",
        },
        {
          name: "etrMax",
          type: "i32",
        },
      ],
    },
    {
      name: "transferAdmin",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "admin",
          isMut: false,
          isSigner: true,
        },
        {
          name: "nextAdmin",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "acceptAdmin",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "pendingAdmin",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [],
    },
    {
      name: "mintWrapTokens",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "position",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wrapMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wrapTokenDestination",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "nftVault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "swapPosition",
          isMut: false,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: true,
          isSigner: true,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
      ],
    },
    {
      name: "burnWrapTokens",
      accounts: [
        {
          name: "wrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "position",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wrapMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wrapTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftVault",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "closePosition",
      accounts: [
        {
          name: "position",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [],
    },
  ],
  accounts: [
    {
      name: "PositionWrapper",
      type: {
        kind: "struct",
        fields: [
          {
            name: "base",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "swapKey",
            type: "publicKey",
          },
          {
            name: "admin",
            type: "publicKey",
          },
          {
            name: "pendingAdmin",
            type: "publicKey",
          },
          {
            name: "wrapMint",
            type: "publicKey",
          },
          {
            name: "positionCount",
            type: "u64",
          },
          {
            name: "etrMax",
            type: "i32",
          },
          {
            name: "etrMin",
            type: "i32",
          },
          {
            name: "reserved",
            type: {
              array: ["u64", 16],
            },
          },
        ],
      },
    },
    {
      name: "Position",
      type: {
        kind: "struct",
        fields: [
          {
            name: "wrapper",
            type: "publicKey",
          },
          {
            name: "owner",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "index",
            type: "u64",
          },
          {
            name: "nftVault",
            type: "publicKey",
          },
          {
            name: "nftMint",
            type: "publicKey",
          },
          {
            name: "wrapBalance",
            type: "u64",
          },
          {
            name: "liquity",
            type: "u128",
          },
          {
            name: "lowerTick",
            type: "i32",
          },
          {
            name: "upperTick",
            type: "i32",
          },
          {
            name: "hold",
            type: "bool",
          },
          {
            name: "reserved",
            type: {
              array: ["u64", 16],
            },
          },
        ],
      },
    },
  ],
  events: [
    {
      name: "NewWrapperEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "wrapMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "admin",
          type: "publicKey",
          index: false,
        },
        {
          name: "etrMin",
          type: "i32",
          index: false,
        },
        {
          name: "etrMax",
          type: "i32",
          index: false,
        },
      ],
    },
    {
      name: "UpdateWrapperEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "previousEtrMin",
          type: "i32",
          index: false,
        },
        {
          name: "previousEtrMax",
          type: "i32",
          index: false,
        },
        {
          name: "etrMin",
          type: "i32",
          index: false,
        },
        {
          name: "etrMax",
          type: "i32",
          index: false,
        },
      ],
    },
    {
      name: "TransferAdminEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "currentAdmin",
          type: "publicKey",
          index: false,
        },
        {
          name: "pendingAdmin",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "AcceptAdminEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "previousAdmin",
          type: "publicKey",
          index: false,
        },
        {
          name: "admin",
          type: "publicKey",
          index: false,
        },
      ],
    },
    {
      name: "MintWrapTokensEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "position",
          type: "publicKey",
          index: false,
        },
        {
          name: "nftMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "authority",
          type: "publicKey",
          index: false,
        },
        {
          name: "lowerTick",
          type: "i32",
          index: false,
        },
        {
          name: "upperTick",
          type: "i32",
          index: false,
        },
        {
          name: "liquity",
          type: "u128",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
      ],
    },
    {
      name: "BurnWrapTokensEvent",
      fields: [
        {
          name: "wrapper",
          type: "publicKey",
          index: false,
        },
        {
          name: "position",
          type: "publicKey",
          index: false,
        },
        {
          name: "nftMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
      ],
    },
  ],
  errors: [
    {
      code: 6000,
      name: "Unauthorized",
      msg: "Unauthorized.",
    },
    {
      code: 6001,
      name: "InsufficientBalance",
      msg: "Insufficient balance.",
    },
    {
      code: 6002,
      name: "CremaPositionNotFound",
      msg: "Crema position not found",
    },
    {
      code: 6003,
      name: "NotInEffectiveRange",
      msg: "Crema position range must overlap with effective range",
    },
    {
      code: 6004,
      name: "WrongSwapPosition",
      msg: "Wrong crema swap position account",
    },
    {
      code: 6005,
      name: "NotMatchSwapKey",
      msg: "Crema swap key not match",
    },
  ],
};
export const CremaPositionWrapperErrors = generateErrorMap(
  CremaPositionWrapperJSON
);
